import { connect, type DefaultRootState } from 'react-redux'
import { actions } from './reducer'
import Notifications from './components/Notifications'

interface RootState extends DefaultRootState {
  notifications: any // Define the notifications property
}

export default connect(
  (state: RootState) => ({
    notifications: state.notifications,
  }),
  (dispatch) => ({
    onNotificationClose: (notification: any) =>
      dispatch(actions.deleteNotification({ notification })),
  }),
)(Notifications)

export { default as reducer, actions, actionTypes } from './reducer'
export { default as middleware } from './middleware'
